import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'app-modal',
  imports: [
    CommonModule,
  ],
  templateUrl: './modal.component.html',
  styles: ``
})
export class ModalComponent implements OnInit, OnDestroy, OnChanges {

  @Input() isOpen = false;
  @Output() close = new EventEmitter<void>();
  @Input() className = '';
  @Input() showCloseButton = true;
  @Input() isFullscreen = false;

  /** Valor de body.overflow ANTES de que este modal lo cambiara. Permite
   *  restaurarlo sin pisar el de otro modal padre que también esté abierto. */
  private previousBodyOverflow: string | null = null;

  constructor(private el: ElementRef) {}

  ngOnInit() {
    if (this.isOpen) {
      this.lockBodyScroll();
    }
  }

  ngOnDestroy() {
    this.unlockBodyScroll();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!changes['isOpen']) return; // ignorar cambios de otros @Input
    const cur = changes['isOpen'].currentValue;
    const prev = changes['isOpen'].previousValue;
    if (cur === prev) return;
    if (cur) {
      this.lockBodyScroll();
    } else {
      this.unlockBodyScroll();
    }
  }

  private lockBodyScroll() {
    if (this.previousBodyOverflow !== null) return; // ya bloqueado
    this.previousBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }

  private unlockBodyScroll() {
    if (this.previousBodyOverflow === null) return;
    document.body.style.overflow = this.previousBodyOverflow;
    this.previousBodyOverflow = null;
  }

  onBackdropClick(event: MouseEvent) {
    if (!this.isFullscreen) {
      this.close.emit();
    }
  }

  onContentClick(event: MouseEvent) {
    event.stopPropagation();
  }

 @HostListener('document:keydown.escape')
  onEscape() {
    if (this.isOpen) {
      this.close.emit();
    }
  }
}
